<template>
    <child-layout title="Import Logs">
        <ag-grid-server-side
            id="importLogHeaders"
            :server-side-datasource="serverSideDatasource"
            suppress-row-click-selection="true"
            :column-defs="columnDefs"
            :default-sort="{ startTime: 'desc' }"
        />
    </child-layout>
</template>

<script>
import ChildLayout from '@/components/layout/ChildLayout'
import AgGridServerSide from '@/components/table/AgGridServerSide'
import ColumnDef from '@/helpers/ag-grid/columnDef/importLog/headers'
import { mapActions, mapGetters } from 'vuex'
import DataSource from '@/helpers/ag-grid/datasource/graphql'

export default {
    name: 'ImportLogHeaders',
    components: {
        ChildLayout,
        AgGridServerSide,
    },
    data: () => ({
        columnDefs: ColumnDef,
    }),
    computed: {
        ...mapGetters({
            fetching: 'importLogHeaders/getFetching',
            items: 'importLogHeaders/getItems',
            lea: 'getDistrictLea',
        }),
    },
    methods: {
        ...mapActions({
            fetchRows: 'importLogHeaders/get',
        }),
        serverSideDatasource: function () {
            const fetch = async (params) => {
                const leaId = this.lea
                await this.fetchRows({ lea: leaId, ...params })

                return this.items
            }

            return {
                getRows: DataSource.partialStore(fetch, 'importLogHeaders').getRows,
            }
        },
    },
}
</script>

<style scoped>

</style>